import { connect } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { redirectPage } from '../../actions/helper';
import { Navigation, INavigationStateProps, INavigationDispatchProps } from './Navigation';

function mapStateToProps(state: IApplicationState): INavigationStateProps {
  return {
    page: state.helper && state.helper.page || 'main',
  };
}

function mapDispatchToProps(): INavigationDispatchProps {
  return {
    redirectPage,
  };
}

export const NavigationContainer = connect<INavigationStateProps, INavigationDispatchProps>
  (mapStateToProps, mapDispatchToProps)(Navigation);
